import TrackerManager from './trackerManager';
import { DriveItemListDisplayType } from '../../containers/DriveItemList/constants';
import { RoutePath,
	RouteParams, RouteParamsTheater, RouteParamsDriveItemDetailPage, RouteParamsDriveItemListPage, RouteParamsStaticPage } from '../../routes/constants';
import { DriveItemListOrigin } from '../../containers/DriveItemListPage/constants';
import { Api } from '../../typings/api';
import UserAgentUtils from '../userAgent';
import Utils from '../';

class StatsUtils {
	private static lastTrackedHash: string;
	public static updateConfig(config: string) {
		const trackerManager = TrackerManager.getInstance();
		const galleryCredentials = Utils.getGalleryCredentials();
		trackerManager.updateConfig(config, UserAgentUtils.isMobileApp, galleryCredentials ? galleryCredentials : undefined);
	}

	public static trackPageView(route: RoutePath, params: RouteParams) {
		const url = window.location.hash;
		if (StatsUtils.lastTrackedHash === url) {
			return;
		}
		const statsTitle = StatsUtils.getStatsTitle(route, params);

		const trackerManager = TrackerManager.getInstance();
		trackerManager.trackEvent('navigation', 'open', statsTitle);
		trackerManager.trackPage('page', url, statsTitle);

		StatsUtils.lastTrackedHash = url;
	}

	public static trackDisplayType(displayType: DriveItemListDisplayType) {
		const trackerManager = TrackerManager.getInstance();
		trackerManager.trackEvent('navigation', `viewMode - ${displayType}`, `change view mode to ${displayType}`);
	}

	public static trackShare(driveItems: Api.DriveItem[]) {
		const trackerManager = TrackerManager.getInstance();
		const sharedIds = driveItems.map(driveItem => driveItem.id).join();
		trackerManager.trackEvent('share', `share - ${sharedIds}`, `share the assets : ${sharedIds}`);
	}

	public static trackDownload(driveItems: Api.DriveItem[]) {
		const trackerManager = TrackerManager.getInstance();
		const downloadedIds = driveItems.map(driveItem => driveItem.id).join();
		trackerManager.trackEvent('download', `download - ${downloadedIds}`, `download the assets : ${downloadedIds}`);
	}

	public static trackDownloadAll() {
		const trackerManager = TrackerManager.getInstance();
		trackerManager.trackEvent('download', `download - all`, `download all assets`);
	}

	// All RoutePath must be in the switch, do not add a default case
	private static getStatsTitle(route: RoutePath, params: RouteParams): string {
		let castedParams;
		switch (route) {
			case RoutePath.Default:
				return `Home Page`;
			case RoutePath.Home:
				return `Home Page`;
			case RoutePath.Authentication:
				return `Authentication Page`;
			case RoutePath.ParametersPage:
				return `Parameters Page`;
			case RoutePath.DriveItemListPage:
				castedParams = params as RouteParamsDriveItemListPage;
				return StatsUtils.getDriveItemListPageTitle(castedParams);
			case RoutePath.TheaterList:
			case RoutePath.Theater:
				castedParams = params as RouteParamsTheater;
				return `Theater Page - ${castedParams.driveItemId}`;
			case RoutePath.DriveItemDetailPage:
				castedParams = params as RouteParamsDriveItemDetailPage;
				return `Detail Page - ${castedParams.driveItemId}`;
			case RoutePath.NotFound:
				return `Page not found`;
			case RoutePath.StaticPage:
				castedParams = params as RouteParamsStaticPage;
				return `Page - ${castedParams.component}`;
		}
	}

	private static getDriveItemListPageTitle(params: RouteParamsDriveItemListPage): string {
		const origin: DriveItemListOrigin = params.origin;
		switch (origin) {
			case DriveItemListOrigin.Downloads:
				return `Download Page`;
			case DriveItemListOrigin.Favorites:
				return `Favorites Page`;
			case DriveItemListOrigin.Folder: {
				if (!params.originParam) {
					return `Gallery Page`;
				}
				return `Folder Page - ${params.originParam}`;
			}
			case DriveItemListOrigin.New:
				return `New Page`;
			case DriveItemListOrigin.Search:
				return `Search Page - ${params.originParam}`;
			case DriveItemListOrigin.Selection:
				return `Selection Page - ${params.originParam}`;
			case DriveItemListOrigin.Updates:
				return `Updates Page`;
		}
	}
}

export default StatsUtils;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/statistics/index.ts